import { useDebouncedValue } from '@mantine/hooks';
import { useEffect } from 'react';
import { QueryBuilderAstNodeType } from '../../../../types';

export const QUERY_AST_SUBMIT_DEBOUNCE_MS = 300;

export type UseDebouncedAstSubmitArgsType = {
  ast: QueryBuilderAstNodeType | null;
  onChange: (ast: QueryBuilderAstNodeType | null) => void;
  delay?: number;
};

export const useDebouncedAstSubmit = ({
  ast,
  onChange,
  delay = QUERY_AST_SUBMIT_DEBOUNCE_MS,
}: UseDebouncedAstSubmitArgsType): void => {
  const [debouncedAst] = useDebouncedValue(ast, delay);

  useEffect(() => {
    if (!debouncedAst) return;
    if (ast !== debouncedAst) return;

    onChange(debouncedAst);
  }, [ast, debouncedAst, onChange]);
};
